import './dbq-modal.js';
import '@polymer/polymer/lib/elements/dom-if.js';
import { GlobalBase } from './global-base.js';
import { html } from '@polymer/polymer/polymer-element.js';

class SwTeacherStudentToggle extends GlobalBase {
  static get is() {
    return 'sw-teacher-student-toggle';
  }

  static get template() {
    return html`
      <template is="dom-if" if="[[isInstructor]]" xmlns="http://www.w3.org/1999/html" xmlns="http://www.w3.org/1999/html">
        <ul class="uk-navbar-nav" aria-label="Toggle Teacher and Student views.">
          <li>
            <a href="[[teacherSideUrl]]" hidden$="[[feedback]]" active$="[[!studentSide]]" aria-current$="[[ariaCurrentTeacher]]" class="user-toggle teacher-side" aria-label="View the Teacher's assignment content page." tabindex="0" role="button">
              <div aria-hidden="true">Teach</div>
              <div aria-hidden="true" class="uk-visible@s">er</div>
              <div aria-hidden="true" class="uk-visible@m word-space-left">Side</div>
            </a>
          </li>
          <li>
            <a href="[[studentSideUrl]]" hidden$="[[feedback]]" active$="[[studentSide]]" aria-current$="[[ariaCurrentStudent]]" class="user-toggle" aria-label="View the Student's assignment content page." tabindex="0" role="button">
              <div aria-hidden="true">Stu</div>
              <div aria-hidden="true" class="uk-visible@s">dent</div>
              <div aria-hidden="true" class="uk-visible@m  word-space-left">Side</div>
            </a>
          </li>
        </ul>
      </template>
    `;
  }

  static get properties() {
    return {
      teacherSideUrl: String,
      studentSideUrl: String,
      studentSide: {
        type: Boolean,
        value: function () {
          return false;
        }
      },
      isInstructor: {
        type: Boolean,
        value: function () {
          return false;
        }
      },
      ariaCurrentStudent: {
        type: String,
        computed: '_computeAriaCurrent(studentSide)',
      },
      ariaCurrentTeacher: {
        type: String,
        computed: '_computeAriaCurrentTeacher(studentSide)',
      },
    };
  }

  _computeAriaCurrent(studentSide) {
    if (studentSide) {
      return 'page';
    }
  }

  _computeAriaCurrentTeacher(studentSide) {
    if (!studentSide) {
      return 'page';
    }
  }


  ready() {
    super.ready();
  }

  _attachDom(dom) {
    this.appendChild(dom);
  }
}
customElements.define(SwTeacherStudentToggle.is, SwTeacherStudentToggle);
